export default __webpack_public_path__ + "_/images/marketplace/slot-all-42d2f8655e67b84fbf5d9d589fb1a45809acf2a5cde34053034c2febe5255a56.png";